module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_c('div', {
    staticClass: "mainPage"
  }, [_c('header', {
    staticClass: "col-md-12"
  }, [_c('Navs'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('md-button', {
    staticClass: "button"
  }, [_c('md-icon', [_vm._v("expand_more")])], 1)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "ourTeam col-md-12"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 box"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "2%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('md-avatar', {
    staticClass: "md-large increase2"
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "name-heading"
  }, [_vm._v("Kunal Mishra")]), _vm._v(" "), _c('h4', [_vm._v("Co-founder")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "col-md-1 col-xs-1 col-md-offset-4"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook-square",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.linkedin.com/in/kunal-mishra-a2056574/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin-square",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.instagram.com/work.teen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "instagram",
      "scale": "6"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 box"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "2%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('md-avatar', {
    staticClass: "md-large increase1"
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "name-heading"
  }, [_vm._v("Aayush Chadha")]), _vm._v(" "), _c('h4', [_vm._v("Co-founder")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "col-md-1 col-xs-1 col-md-offset-4"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/",
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook-square",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.linkedin.com/in/aayush-c-970566107/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin-square",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.instagram.com/work.teen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "instagram",
      "scale": "6"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 box"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "2%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('md-avatar', {
    staticClass: " md-large increase4"
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "name-heading"
  }, [_vm._v("Utsav Gupta")]), _vm._v(" "), _c('h4', [_vm._v("Data Collection Team, Delhi")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "col-md-1 col-xs-1 col-md-offset-4"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook-square",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.linkedin.com/in/utsav22g/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin-square",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.instagram.com/work.teen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "instagram",
      "scale": "6"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 box"
  }, [_c('div', {
    staticStyle: {
      "padding-bottom": "2%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('md-avatar', {
    staticClass: "md-large increase5"
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "name-heading"
  }, [_vm._v("Anubhav Ghosh")]), _vm._v(" "), _c('h4', [_vm._v("Front-end Developer")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "0 auto"
    }
  }, [_c('div', {
    staticClass: "col-md-1 col-xs-1 col-md-offset-4"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "facebook-square",
      "scale": "2"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.facebook.com/workteen/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "envelope",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.linkedin.com/in/anubhav-ghosh-50609314b/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "linkedin-square",
      "scale": "6"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1 col-xs-1"
  }, [_c('a', {
    staticStyle: {
      "color": "#427aa1"
    },
    attrs: {
      "href": "https://www.instagram.com/anubhavg8/"
    }
  }, [_c('icon', {
    attrs: {
      "name": "instagram",
      "scale": "6"
    }
  })], 1)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "ourWork"
  })])]), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-8 col-md-offset-2 briefText"
  }, [_c('h1', {
    staticClass: "mainHeader"
  }, [_vm._v("Who We Are ")]), _vm._v(" "), _c('h3', [_vm._v(" WorkTeen is an initiative to help high school students across various Indian cities find internships, volunteering and research opportunities. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "aboutUs"
  }, [_c('div', {
    staticClass: "col-md-12 text-center",
    staticStyle: {
      "padding-left": "5%",
      "padding-right": "5%"
    }
  }, [_c('h1', {
    staticClass: "col-md-12 heading"
  }, [_vm._v("\r\n              About WorkTeen\r\n              "), _c('hr', {
    staticClass: "col-md-6",
    staticStyle: {
      "margin-top": "5%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "content1"
  }, [_vm._v("\r\n                We work with non governmental organisations, various firms and research institutes to help high school students dicover new passions and contribute towards the community.")]), _c('p', {
    staticClass: "content1"
  }, [_vm._v(" We are constantly on the look out for new opportunities and if you are in a position to help us expand our opportunities, we will love to talk to you. ")]), _c('p', {
    staticClass: "content1"
  }, [_vm._v("You can leave us your contact details by messaging on our social media channels. Either way, a member of our team will get in touch with you at the earliest.\r\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "heading"
  }, [_vm._v("The WorkTeen Team\r\n        "), _c('hr', {
    staticClass: "col-md-3"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4673f102","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutUs.vue
// module id = 895
// module chunks = 1